module.exports = __webpack_public_path__ + "img/horizontal_5_1_6005.7bcc6bb6.png";